import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useContext } from "react";
import { multiStepContext } from "../StepContext";
import FirstSteps from "../Style/FirstStep.css";

const FirstStep = () => {
  const { setCurrentStep, setUserData, userData } =
    useContext(multiStepContext);

  return (
    <div className="firststep">
      <div className="section1 personalInfosection">
        <h2>Personal info</h2>
        <p>Please provide your name, email address, and phone number .</p>
      </div>
      <div className="formList">
        <form>
          <div className="form-group mb-4 mt-5">
            <label for="formGroupExampleInput">Name</label>
            <input
              onChange={(e) =>
                setUserData({ ...userData, firstName: e.target.value })
              }
              value={userData["firstName"]}
              label="First Name"
              type="text"
              className="form-control mt-2"
              id="formGroupExampleInput"
              placeholder="Meshkat Hossain Himu"
            />
          </div>
          <div className="form-group mb-4">
            <label for="formGroupExampleInput2 ">Email address</label>
            <input
              onChange={(e) =>
                setUserData({ ...userData, lastName: e.target.value })
              }
              value={userData["lastName"]}
              label="Last Name"
              type="text"
              className="form-control mt-2"
              id="formGroupExampleInput2"
              placeholder="meshkat.hossain.himu@gmail.com"
            />
          </div>
          <div className="form-group mb-4">
            <label for="formGroupExampleInput2">Phone Number</label>
            <input
              onChange={(e) =>
                setUserData({ ...userData, contact: e.target.value })
              }
              value={userData["contact"]}
              label="Contact"
              type="text"
              className="form-control mt-2"
              id="formGroupExampleInput2"
              placeholder="01572331372"
            />
          </div>
        </form>
      </div>
      {/* <div className="textField">
        <TextField
          onChange={(e) =>
            setUserData({ ...userData, firstName: e.target.value })
          }
          value={userData["firstName"]}
          label="First Name"
          margin="normal"
          variant="outlined"
          color="secondary"
        />
      </div>
      <div>
        <TextField
          onChange={(e) =>
            setUserData({ ...userData, lastName: e.target.value })
          }
          value={userData["lastName"]}
          label="Last Name"
          margin="normal"
          variant="outlined"
          color="secondary"
        
        />
      </div>

      <div>
        <TextField
          onChange={(e) =>
            setUserData({ ...userData, contact: e.target.value })
          }
          value={userData["contact"]}
          label="Contact"
          margin="normal"
          variant="outlined"
          color="secondary"
        />
      </div> */}
<div className="btn2">

      <button
        className="nextBtn"
        onClick={() => setCurrentStep(2)}
        variant="contained"
        color="primary"
      >
        Next Step
      </button>
</div>
    </div>
  );
};

export default FirstStep;
